import { Component } from 'react';

/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unused-class-component-methods */
class RequestComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
      result: null,
      error: null,
    };
  }

  componentWillUnmount() {
    this.setState({ request: null });
  }

  trackRequest(request) {
    this.setState({ request, error: null });

    request.then(
      response => this.resolve(request, { result: response }),
      error => this.resolve(request, { error }),
    );
    return request;
  }

  isLoading() {
    return !!this.state.request;
  }

  resolve(request, update) {
    if (this.state.request === request) {
      this.setState({ request: null, ...update });
    }
  }
}

export default RequestComponent;
